import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import clsx from 'clsx';
import {
    Box, FormControl, OutlinedInput, FormHelperText, InputAdornment,
    Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Typography, Paper
} from '@material-ui/core';

import { StateContext } from '../../../../context/Provider';

const GradingItem = (props) => {

    const appState = useContext(StateContext);
    const { authState } = appState;

    const { classes, cw } = props;
    const [gradeValue, setGradeValue] = useState(cw.grade);
    const [successMsg, setSuccessMsg] = useState(null);

    const handleGradeChange = (grade) => {

        axiosConfig.post(`/grades`, {
            student_grade_id: cw.student_grade_id,
            grade
        })
        .then((res) => {
            if (res.data.status_code == 'ok') {
                setSuccessMsg('Saved ✓');
            }
        })
        .catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        // console.log(cw)
        if (gradeValue !== cw.grade) {

            // prevent students to modify their grades
            if (authState.user.role_id !== 5) {
                const timeOutId = setTimeout(() => handleGradeChange(gradeValue), 500);
                return () => clearTimeout(timeOutId);
            }
        }

    }, [gradeValue]);

    return (
        <TableCell align="left" style={{verticalAlign: 'top'}}>
            <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined">
                <OutlinedInput
                    classes={{ input: classes.input }}
                    type="number"
                    id="outlined-adornment-weight"
                    endAdornment={<InputAdornment position="end">/{cw.total_pts || 0}</InputAdornment>}
                    aria-describedby="outlined-weight-helper-text"
                    value={gradeValue}
                    onChange={event => {setSuccessMsg(''); setGradeValue(event.target.value.replace(/\D/,'')); }}
                    disabled={authState.user.role_id === 5}
                />
                {successMsg && (
                    <FormHelperText className={classes.helper}>
                        {successMsg}
                    </FormHelperText>
                )}
            </FormControl>
        </TableCell>
    );
}

export default GradingItem;